import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from "./tooltip";
import Icon from "./icon";
var HelperTooltip = function (_a) {
    var children = _a.children;
    return (_jsx(Tooltip, { content: children, children: _jsx(Icon, { onClick: function () { }, name: "information-circle-contained" }) }));
};
export default HelperTooltip;
